module.exports = __webpack_public_path__ + "static/media/OPSLogo.7dfd4a85.png";